export const CCPA_ANALYTICS = "remedi_ccpa_analytics";
export const CCPA_MARKETING = "remedi_ccpa_marketing";
export const CCPA_PERSONALIZATION = "remedi_ccpa_personalization";
export const ACCESSIBILITY = "remedi_accessibility";
